import React, { useEffect, useState } from 'react';
import { Card, Button, Tabs, Tab} from 'react-bootstrap';
import { useParams, useHistory } from "react-router-dom";
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './BookingSingle.scss';
import BookingGeneral from './BookingGeneral/BookingGeneral';
import BookingResources from './BookingResources/BookingResources';
import BookingBilling from './BookingBilling/BookingBilling';
import BookingGuests from './BookingGuests/BookingGuests';
import BookingResourceGuests from './BookingResourceGuests/BookingResourceGuests';
import Field from '../../Shared/Wizard/Field/Field';

function BookingSingle(props) {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const history = useHistory();
    let { id } = useParams();

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(false);

    const [forceUpdateBooking, setForceUpdateBooking] = useState(0);
    const [forceUpdate, setForceUpdate] = useState(0);

    const [booking, setBooking] = useState<any>({});

    const [allResources, setAllResources] = useState<Array<any>>([]);
    const [allResourceTypes, setAllResourceTypes] = useState<Array<Object>>([]);
    const [allDeals, setAllDeals] = useState<Array<Object>>([]);
    const [allEvents, setAllEvents] = useState<Array<Object>>([]);
    const [people, setPeople] = useState<Array<Object>>([]);
    const [customers, setCustomers] = useState<Array<Object>>([]);
    const [counter, setCounter] = useState(0);

    const [updateTable, setUpdateTable] = useState(0);
    // const today = new Date();
    //const currentDate = today.getFullYear() + "" + ((today.getMonth() + 1) <= 9 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)) + "" + today.getDate() ;

    function handleSaveBtn() {
        if (booking._id == undefined || booking._id == "") {
            handleSaveNew();
        } else {
            handleSaveEdit();
        }
        localStorage.removeItem("editedItems");
    }
    
    function handleSaveNew() {
        setSaving(true);
        //set default deal when there's no selected deal
        booking["deal"] = booking.deal == undefined ? allDeals.find(item => item["isDefaultDeal"] == true): booking.deal;
        booking["status"] = booking["status"] != undefined ? booking.status : "new"

        if( counter == 0 ){
            axios.post('/api/counters', {
                key: "bookingid",
                seq: 0,
            }, {
                headers: {'x-access-token': auth.user["token"]}
            }).then((res) => {
                axios.post('/api/bookings', {
                    ...booking,

                }
                ,{
                    headers: {'x-access-token': auth.user["token"]}
                })
                .then(function (response) {
                    axios.put('/api/resources/updatemany', {
                        resources: allResources.filter(i => i["changed"] ?? false).map(i => { return {_id: i._id, bookings: i.bookings.map(b => { return {...b, bookingId: b.bookingId == undefined ? response.data._id : b.bookingId, bookingtimes: b.bookingtimes.map(t => { return { ...t, state: undefined } })} })} })
                    }, {
                        headers: {'x-access-token': auth.user["token"]}
                    }).then((res) => {
                        setUpdateTable(updateTable + 1);
                        setForceUpdate(forceUpdate + 1);
                        fetchData();
                        setSaving(false);
                        setBooking(response.data);
                        history.push("/booking/" + response.data._id);
                        notifySuccess(t("booking.toast_created"));
                    });
                })
            });

        } else {
            axios.post('/api/bookings', {
                ...booking
            }
            ,{
                headers: {'x-access-token': auth.user["token"]}
            })
            .then(function (response) {
                axios.put('/api/resources/updatemany', {
                    resources: allResources.filter(i => i["changed"] ?? false).map(i => { return {_id: i._id, bookings: i.bookings.map(b => { return {...b, bookingId: b.bookingId == undefined ? response.data._id : b.bookingId, bookingtimes: b.bookingtimes.map(t => { return { ...t, state: undefined } })} })} })
                }, {
                    headers: {'x-access-token': auth.user["token"]}
                }).then((res) => {
                    setUpdateTable(updateTable + 1);
                    setForceUpdate(forceUpdate + 1);
                    fetchData();
                    setSaving(false);
                    setBooking(response.data);
                    history.push("/booking/" + response.data._id);
                    notifySuccess(t("booking.toast_created"));
                });
            })
        }
    };

    function handleCustomerToGuest(customer) {
        axios.post(
            "/api/persons",
            {
                lastname: customer.lastname,
                firstname: customer.firstname,
                email: customer.email,
                organization: customer.organizationName,
                phone: customer.phone,
            },
            {
                headers: {'x-access-token': auth.user["token"]}
            }
        ).then(res => {
            notifySuccess(t("people.toast_people_created"));

            if(res.data != undefined){
                booking.guests = [...booking.guests, {_id: res.data._id}];
            }

            axios.put(
                "/api/bookings/" + booking._id,
                {
                    ...booking,
                },
                {
                    headers: {'x-access-token': auth.user["token"]}
                }
            );
            
            notifySuccess(t("booking.toast_updated"));
            setUpdateTable(updateTable + 1);
            setForceUpdate(forceUpdate + 1);
            fetchData();
        });
    }
    
    function handleSaveEdit() {
        setSaving(true);
        axios.put('/api/bookings/' + booking["_id"], {
            ...booking
         }, {
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            axios.put('/api/resources/updatemany', {
                resources: allResources.filter(i => i["changed"] ?? false).map(i => {
                    return {
                        _id: i._id,
                        bookings: i.bookings.map(b => {
                            return {
                                ...b,
                                bookingId: b.bookingId == undefined ? response.data._id : b.bookingId,
                                bookingtimes: b.bookingtimes != undefined ? b.bookingtimes.map(t => {
                                    return {
                                        ...t,
                                        state: t.state == "new" ? "existing" : t.state
                                    }
                                }) : []
                            }
                        })
                    }
                })
            }, {
                headers: {'x-access-token': auth.user["token"]}
            }).then((res) => {
                setUpdateTable(updateTable + 1);
                setForceUpdate(forceUpdate + 1);
                fetchData();
                setSaving(false);
                notifySuccess(t("booking.toast_updated"));
            });
        });
    };

    function fetchDataByBookingId() {
        axios.single({
            method: "get",
            url: "/api/bookings/" + id,
            responseType: "json",
            headers: {'x-access-token': auth.user["token"]}
        })
        .then((res) => {
           setBooking(res.data);
        })
        .catch(err => console.log(err));
    }

    function fetchData() {
        setLoading(true);
        axios.all([
            axios.single({
                method: "get",
                url: "/api/resourceTypes",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/resources",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/deals",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/events",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/persons",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/counters",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/customers/",
                responsType: "json",
                headers: {'x-access-token': auth.user["token"]}
            })
        ])
        .then(axios.spread((...res) => {
            setAllResourceTypes(res[0]["data"]);
            setAllResources(res[1]["data"]);
            setAllDeals(res[2]["data"]);
            setAllEvents(res[3]["data"]);
            setPeople(res[4]["data"]);
            setCounter(res[5]["data"].length != 0 ? res[5]["data"][0]["seq"] : 0);
            setCustomers(res[6]["data"]);
            setLoading(false);
        }))
        .catch(err => console.log(err));
    }

    function getCustomers(){
        axios.all([
            axios.single({
                method: "get",
                url: "/api/customers/",
                responsType: "json",
                headers: {'x-access-token': auth.user["token"]}
            })
        ])
        .then(axios.spread((...res) => {
            setCustomers(res[0]["data"]);
        }))
        .catch(err => console.log(err));
    }
    
    useEffect(() => {
        fetchData();
        if(id != undefined){
            fetchDataByBookingId();
        }
    }, []);

    useEffect(() => {
        fetchData();
        if(id != undefined){
            fetchDataByBookingId();
        }
    }, [forceUpdateBooking]);

    return (
        <div className="maincontent">
            <div className="myaccount-container">
                <div className="saving-overlay" style={saving ? {} : {display: "none"}}>
                    <p>{t("booking.overlay.saving")}</p>
                </div>
                <div className="saving-overlay" style={loading ? {} : {display: "none"}}>
                    <p>{t("booking.overlay.loading")}</p>
                </div>
                <div className="pagetitle-container">
                    <h1>{t("booking.page_name")}</h1>
                </div>
                <p>{booking.bookingnumber != undefined ? booking.bookingnumber : ""}</p>
                <div style={{float: "right", top:"50px", right:"30px",  position:"absolute"}} className="no-print">
                    <Field
                        type="select"
                        title={t("booking.general.status")}
                        value={booking.status != undefined ? { label: "", value: booking.status } : ""}
                        onChange={(val) => {
                            let tempBooking = booking;
                            tempBooking["status"] =  val.value;
                        }}
                        options={{
                            choosetext: t("booking.general.status_choosetext"),
                                choices: [
                                    { label: t("booking.general.status_new"), value: "new" },
                                    { label: t("booking.general.status_inprocess"), value: "inprocess" },
                                    { label: t("booking.general.status_completed"), value: "completed" },
                                    { label: t("booking.general.status_invoiced"), value: "invoiced" },
                                ]
                            }}
                    ></Field>
                </div>
                <div className="col col-md-12">
                    <Card style={{marginTop: "60px", borderTop: "1px solid #fcb85f"}}>
                        <Card.Body>
                            <Tabs 
                                className="no-print" 
                                style={{ marginTop: "-62px"}} 
                                defaultActiveKey="general_info" 
                                id="general_info" 
                                onSelect={(eventkey, evt) => 
                                    eventkey == "timeline_info" ||
                                    eventkey == "resources_info" ?
                                        setForceUpdate(forceUpdate + 1)
                                    : null }
                            >
                                <Tab eventKey="general_info" title={t("booking.general_information")} >
                                    <BookingGeneral
                                        booking={booking}
                                        counter={counter}
                                        allResourceTypes={allResourceTypes}
                                        allDeals={allDeals}
                                        allEvents={allEvents}
                                        allPeople={people}
                                        customers={customers}
                                        onChange={(changedBooking) => setBooking(changedBooking)}
                                        onUpdateCustomer={getCustomers}
                                    ></BookingGeneral>
                                    <br/>
                                </Tab>
                                <Tab eventKey="resources_info" title={t("booking.resources_information")}>
                                    <div style={{ marginTop: '20px' }}>
                                        <BookingResources
                                            fetchDataPass={() => {
                                                setForceUpdateBooking(forceUpdate + 1);
                                            }}
                                            booking={booking}
                                            forceUpdate={forceUpdate}
                                            allDeals={allDeals}
                                            allResourceTypes={allResourceTypes}
                                            allResources={allResources}
                                            onChange={(changedBooking) => {
                                                setBooking(changedBooking);
                                                setForceUpdate(forceUpdate + 1);
                                            }}
                                            onResourcesChange={(resourcesChanged) => {
                                                setAllResources(resourcesChanged);
                                                setForceUpdate(forceUpdate + 1);
                                            }}
                                            events={allEvents}
                                        ></BookingResources>
                                    </div>
                                </Tab>
                                <Tab eventKey="guests_info" title={t("booking.guests_information")}>
                                    <div style={{ marginTop: '20px' }}>
                                        <BookingGuests
                                            booking={booking}
                                            people={people}
                                            onChange={(changedBooking) => setBooking(changedBooking)}
                                            onGuestAdd={() => handleSaveBtn()}
                                            onGuestDelete={() => handleSaveBtn()}
                                            allResources={allResources}
                                            allResourceTypes={allResourceTypes}
                                            customers={customers}
                                            onCustomerToPerson={handleCustomerToGuest}
                                        ></BookingGuests>
                                    </div>
                                </Tab>
                                <Tab eventKey="resourceguests_info" title={t("booking.resourceguests_information")}>
                                    <div style={{ marginTop: '20px' }}>
                                        <BookingResourceGuests
                                            booking={booking}
                                            people={people}
                                            resources={allResources}
                                            onResourcesChange={(resourcesChanged) => {
                                                setAllResources(resourcesChanged);
                                                setForceUpdate(forceUpdate + 1);
                                            }}
                                        ></BookingResourceGuests>
                                    </div>
                                </Tab>
                                <Tab eventKey="billing_info" title={t("booking.billing_information")}>
                                    <BookingBilling
                                        booking={booking}
                                        allResourceTypes={allResourceTypes}
                                        allResources={allResources}
                                        onChange={(changedBooking) => setBooking(changedBooking)}
                                    ></BookingBilling>
                                </Tab>
                            </Tabs>
                            <br/>
                            <Button className="no-print" style={{ float: "right" }} onClick={(evt) => handleSaveBtn()} > {t("booking.save")}</Button>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
}

export default BookingSingle;